import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/plus-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-56e6dc00")

_pushScopeId("data-v-56e6dc00")
const _hoisted_1 = { class: "mypage-favorites" }
const _hoisted_2 = { class: "mypage-favorites-all-title-area" }
const _hoisted_3 = { class: "mypage-favorites-all-title-area-title" }
const _hoisted_4 = { class: "commonTextBodyStrong mypage-favorites-all-title-area-title-text" }
const _hoisted_5 = { class: "commonButtonText mypage-favorites-all-title-area-button-text" }
const _hoisted_6 = { class: "mypage-favorites-all-area-nothing-container" }
const _hoisted_7 = { class: "mypage-favorites-all-title-area" }
const _hoisted_8 = { class: "mypage-favorites-all-title-area-title" }
const _hoisted_9 = { class: "commonTextBodyStrong mypage-favorites-all-title-area-title-text" }
const _hoisted_10 = { class: "commonButtonText mypage-favorites-all-title-area-button-text" }
const _hoisted_11 = { class: "mypage-favorites-all-area-nothing-container" }
const _hoisted_12 = { class: "mypage-favorites-title-area" }
const _hoisted_13 = { class: "mypage-favorites-title-area-title" }
const _hoisted_14 = { class: "commonTextBodyStrong mypage-favorites-title-area-title-text" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "mypage-favorites-folder-append-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_16 = { class: "mypage-favorites-folder-append-button-text-container" }
const _hoisted_17 = { class: "commonButtonText mypage-favorites-folder-append-button-text" }
const _hoisted_18 = { class: "mypage-favorites-folder-area-nothing-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonHorizontalRecipeList = _resolveComponent("CommonHorizontalRecipeList")
  const _component_MyListFolderList = _resolveComponent("MyListFolderList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.favoriteFoodTitle), 1)
      ]),
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectFoodList(...args))),
        class: "mypage-favorites-all-title-area-button",
        style: _ctx.styleAllFoodListButton
      }, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.favoriteFoodReferenceTitle), 1)
      ], 4)
    ]),
    _createVNode(_component_CommonHorizontalRecipeList, {
      class: "mypage-favorites-all-area",
      style: _ctx.styleFoodList,
      recipes: _ctx.displayFoodList,
      isFoods: true,
      onOnClick: _ctx.selectFood
    }, null, 8, ["style", "recipes", "onOnClick"]),
    _createVNode("div", {
      class: "mypage-favorites-all-area-nothing",
      style: _ctx.styleFoodListNothing
    }, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          innerHTML: _ctx.nothingFoodsMessage,
          class: "commonTextCaption1 mypage-favorites-all-area-nothing-text"
        }, null, 8, ["innerHTML"])
      ])
    ], 4),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("span", _hoisted_9, _toDisplayString(_ctx.favoriteRcipeTitle), 1)
      ]),
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectRecipeList(...args))),
        class: "mypage-favorites-all-title-area-button",
        style: _ctx.styleAllRecipeListButton
      }, [
        _createVNode("span", _hoisted_10, _toDisplayString(_ctx.recipeAllReferenceTitle), 1)
      ], 4)
    ]),
    _createVNode(_component_CommonHorizontalRecipeList, {
      class: "mypage-favorites-all-area",
      style: _ctx.styleRecipeList,
      recipes: _ctx.displayRecipeList,
      onOnClick: _ctx.selectRecipe
    }, null, 8, ["style", "recipes", "onOnClick"]),
    _createVNode("div", {
      class: "mypage-favorites-all-area-nothing",
      style: _ctx.styleRecipeListNothing
    }, [
      _createVNode("div", _hoisted_11, [
        _createVNode("div", {
          innerHTML: _ctx.nothingRecipeMessage,
          class: "commonTextCaption1 mypage-favorites-all-area-nothing-text"
        }, null, 8, ["innerHTML"])
      ])
    ], 4),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode("span", _hoisted_14, _toDisplayString(_ctx.folderTitle), 1)
      ])
    ]),
    _createVNode("div", {
      class: "mypage-favorites-folder-append",
      style: _ctx.styleAppendFolder
    }, [
      _createVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectAppendFolder(...args))),
        class: "mypage-favorites-folder-append-button"
      }, [
        _hoisted_15,
        _createVNode("div", _hoisted_16, [
          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.appendFolderButtonTitle), 1)
        ])
      ])
    ], 4),
    _createVNode(_component_MyListFolderList, {
      folderList: _ctx.displayFolderList,
      style: _ctx.styleFolderList,
      onOnClick: _ctx.selectFolder,
      onMoveFolder: _ctx.moveFolder
    }, null, 8, ["folderList", "style", "onOnClick", "onMoveFolder"]),
    _createVNode("div", {
      class: "mypage-favorites-folder-area-nothing",
      style: _ctx.styleFolderListNothing
    }, [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", {
          innerHTML: _ctx.nothingFolderMessage,
          class: "commonTextCaption1 mypage-favorites-folder-area-nothing-text"
        }, null, 8, ["innerHTML"])
      ])
    ], 4)
  ]))
})